import React from 'react';
import { Col, DatePicker, Form, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const DateSection = ({ isView }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Le Date')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Data pubblicazione')} name='date_from'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Data scadenza')} name='date_to'>
          <DatePicker
            disabled={isView}
            format={'DD MMMM YYYY'}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(DateSection);
